import React from 'react';
import ReCAPTCHA from "react-google-recaptcha";
const recaptchaRef = React.createRef();

const ReCAPTCHAA  = React.memo((props) => {
  return <>
   <div className={`sas-input  ${props.invalid}`} >
    <form>
      <ReCAPTCHA
        ref={recaptchaRef}
        sitekey="6LfV4E4UAAAAALXKbivkMgQJXBvDYgNfhV6OREDP"
        onChange={props.onChangeCaptch}
        hl ={props.language}
      />
    </form>
    <span className="message" element="message">{props.error}</span>
    </div>
 </>
});
export default ReCAPTCHAA;